module.exports = __webpack_public_path__ + "static/img/toner_map_icon.7e0362c.png";